import React from "react";
import { PrimaryButton } from "../../../shared/Buttons/Buttons";
import "./interviewLogsCardView.scss";

interface InterviewLogsHistoryPaginationProps {
  currentPage: number;
  totalPages: number;
  totalCount: number;
  itemsPerPage: number;
  onPageChange: (page: number) => void;
}

const InterviewLogsHistoryPagination: React.FC<
  InterviewLogsHistoryPaginationProps
> = ({
  currentPage,
  totalPages,
  totalCount,
  itemsPerPage,
  onPageChange,
}) => {
  if (totalCount === 0) return null;

  const startIndex = (currentPage - 1) * itemsPerPage + 1;
  const endIndex = Math.min(currentPage * itemsPerPage, totalCount);
  const safeTotalPages = Math.max(totalPages, 1);

  return (
    <div className="ilcv-pagination">
      <p className="ilcv-pagination__info">
        Showing {startIndex}-{endIndex} of {totalCount}
      </p>
      <div className="ilcv-pagination__controls">
        <PrimaryButton
          text="Previous"
          type="button"
          size="sm"
          onClick={() => onPageChange(currentPage - 1)}
          disable={currentPage <= 1}
        />
        <span className="ilcv-pagination__page-label">
          Page {currentPage} of {safeTotalPages}
        </span>
        <PrimaryButton
          text="Next"
          type="button"
          size="sm"
          onClick={() => onPageChange(currentPage + 1)}
          disable={currentPage >= safeTotalPages}
        />
      </div>
    </div>
  );
};

export default InterviewLogsHistoryPagination;
